import { render } from "./CardDetailComponent.vue?vue&type=template&id=15ca5f04"
import script from "./CardDetailComponent.vue?vue&type=script&lang=js"
export * from "./CardDetailComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__